import { Box, Flex } from '@chakra-ui/react';
import { useClientQuery } from 'generated/graphql';
import { Outlet, useParams } from 'react-router-dom';
import Contracts from './Contracts';
import Files from './Files';
import Header from './Header';

function Client() {
  const { clientId } = useParams() as { clientId: string };
  const { loading, data } = useClientQuery({ variables: { id: clientId } });

  if (loading || !data) return null;

  return (
    <Flex direction="column" height="100%" bg="white" borderRadius="2xl" boxShadow="md">
      <Header client={data.client} />
      <Box flex={1} overflowY="auto">
        <Contracts />
        <Files clientId={clientId} />
      </Box>
      <Outlet />
    </Flex>
  );
}

export default Client;
